import script from "./ImigrationReportIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ImigrationReportIndex.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__